import React from "react"
import { ErrorBoundary } from "react-error-boundary";
import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import mainRouter from "@/routes/mainRouter"
import { OrderProvider } from "./providers/OrderProvider";
import "./assets/css/styles.css"
import "./assets/scss/styles.scss";

const ErrorFallback = () => {
  return (
    <div>
      <h2>問題が発生しました</h2>
    </div>
  );
};

const App: React.FC = () => {

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <HelmetProvider>
        <OrderProvider>
          <RouterProvider router={mainRouter} />
        </OrderProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
